const debounce = (f, ms) => {
  let delay = false

  return function wrapped() {
    if (delay) return

    // eslint-disable-next-line prefer-rest-params
    f.apply(this, arguments)
    delay = true

    setTimeout(() => {
      delay = false
    }, ms)
  }
}

export default debounce
